import { MAIN_QUESTS_GROUP } from "@/constants";
import { RuleId } from "@/domain/gems-game/domain/lib/LatestEarnings";
import { Quest as MainQuest } from "@/domain/gems-game/domain/lib/Quest";
import { EarningType } from "@/domain/gems-game/domain/lib/Quest";
import { QuestTileType } from "@/domain/gems-game/domain/lib/TileType";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

export const treeverseMainQuestRuleDaily = new MainQuest({
  id: RuleId.TREEVERSE,
  customTitle: [],
  customComingSoonTitle: [],
  caption: "Complete daily quest in Treeverse",
  subtext: [],
  logo: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z_82HOvxEdbNPGlX_treeverse-rule-logo.webp?auto=format,compress",
  ),
  backgroundMediaUrl: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z6Kv5ZbqstJ9-OxV_Treeverse_background_04.webp?auto=format,compress",
  ),
  gemsAmount: "210",
  analyticsId: "treeverse-quest",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OnChain,
  description: [],
  isGemDistributionPending: true,
  rules: {
    items: [
      "Complete daily quest in Treeverse",
      "Gems will be distributed weekly",
    ],
  },
  startDate: new Date("2025-04-19T12:00:00Z"),
  endDate: new Date("2025-05-19T12:00:00Z"),
  availableOn: ["iOS", "Android", "Windows"],
});

export const treeverseMainQuestRule1 = new MainQuest({
  id: RuleId.TREEVERSE,
  customTitle: [],
  customComingSoonTitle: [],
  caption: "Reach level 30 in Treeverse",
  subtext: [],
  logo: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z_82HOvxEdbNPGlX_treeverse-rule-logo.webp?auto=format,compress",
  ),
  backgroundMediaUrl: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z6Kv5ZbqstJ9-OxV_Treeverse_background_04.webp?auto=format,compress",
  ),
  gemsAmount: "25",
  analyticsId: "treeverse-quest",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OnChain,
  description: [],
  isGemDistributionPending: true,
  rules: {
    items: ["Reach Level 30 in Treeverse", "Gems will be distributed weekly"],
  },
  startDate: new Date("2025-04-19T12:00:00Z"),
  endDate: new Date("2025-05-19T12:00:00Z"),
  availableOn: ["iOS", "Android", "Windows"],
});

export const treeverseMainQuestRule2 = new MainQuest({
  id: RuleId.TREEVERSE,
  customTitle: [],
  customComingSoonTitle: [],
  caption: "Max out all Skilling Master to Level 60",
  subtext: [],
  logo: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z_82HOvxEdbNPGlX_treeverse-rule-logo.webp?auto=format,compress",
  ),
  backgroundMediaUrl: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z6Kv5ZbqstJ9-OxV_Treeverse_background_04.webp?auto=format,compress",
  ),
  gemsAmount: "50",
  analyticsId: "treeverse-quest",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OnChain,
  description: [],
  isGemDistributionPending: true,
  rules: {
    items: [
      "Max out all Skilling to Level 60",
      "Gems will be distributed weekly",
    ],
  },
  startDate: new Date("2025-04-19T12:00:00Z"),
  endDate: new Date("2025-05-19T12:00:00Z"),
  availableOn: ["iOS", "Android", "Windows"],
});

export const treeverseMainQuestRule3 = new MainQuest({
  id: RuleId.TREEVERSE,
  customTitle: [],
  customComingSoonTitle: [],
  caption: "Complete End Game Dungeon Runs",
  subtext: [],
  logo: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z_82HOvxEdbNPGlX_treeverse-rule-logo.webp?auto=format,compress",
  ),
  backgroundMediaUrl: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z6Kv5ZbqstJ9-OxV_Treeverse_background_04.webp?auto=format,compress",
  ),
  gemsAmount: "",
  analyticsId: "treeverse-quest",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OnChain,
  description: [],
  isGemDistributionPending: true,
  rules: {
    items: [
      "Complete End Game Dungeon Runs (only for top 20% of users)",
      "Boost your chance of getting rewards",
    ],
  },
  startDate: new Date("2025-04-19T12:00:00Z"),
  endDate: new Date("2025-05-19T12:00:00Z"),
  availableOn: ["iOS", "Android", "Windows"],
});

export const treeverseMainQuestRule4 = new MainQuest({
  id: RuleId.TREEVERSE,
  customTitle: [],
  customComingSoonTitle: [],
  caption: "Collect Gold",
  subtext: [],
  logo: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z_82HOvxEdbNPGlX_treeverse-rule-logo.webp?auto=format,compress",
  ),
  backgroundMediaUrl: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z6Kv5ZbqstJ9-OxV_Treeverse_background_04.webp?auto=format,compress",
  ),
  gemsAmount: "",
  analyticsId: "treeverse-quest",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OnChain,
  description: [],
  isGemDistributionPending: true,
  rules: {
    items: [
      "Collect Gold (only for top 20% of users)",
      "Boost your chance of getting rewards",
    ],
  },
  startDate: new Date("2025-04-19T12:00:00Z"),
  endDate: new Date("2025-05-19T12:00:00Z"),
  availableOn: ["iOS", "Android", "Windows"],
});

export const treeverseMainQuestRule5 = new MainQuest({
  id: RuleId.TREEVERSE,
  customTitle: [],
  customComingSoonTitle: [],
  caption: "Earn XP",
  subtext: [],
  logo: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z_82HOvxEdbNPGlX_treeverse-rule-logo.webp?auto=format,compress",
  ),
  backgroundMediaUrl: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z6Kv5ZbqstJ9-OxV_Treeverse_background_04.webp?auto=format,compress",
  ),
  gemsAmount: "",
  analyticsId: "treeverse-quest",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OnChain,
  description: [],
  isGemDistributionPending: true,
  rules: {
    items: [
      "Earn XP (only for top 20% of users)",
      "Boost your chance of getting rewards",
    ],
  },
  startDate: new Date("2025-04-19T12:00:00Z"),
  endDate: new Date("2025-05-19T12:00:00Z"),
  availableOn: ["iOS", "Android", "Windows"],
});

export const treeverseMainQuestRule6 = new MainQuest({
  id: RuleId.TREEVERSE,
  customTitle: [],
  customComingSoonTitle: [],
  caption: "Collect Monster Shards",
  subtext: [],
  logo: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z_82HOvxEdbNPGlX_treeverse-rule-logo.webp?auto=format,compress",
  ),
  backgroundMediaUrl: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z6Kv5ZbqstJ9-OxV_Treeverse_background_04.webp?auto=format,compress",
  ),
  gemsAmount: "",
  analyticsId: "treeverse-quest",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OnChain,
  description: [],
  isGemDistributionPending: true,
  rules: {
    items: [
      "Collect Monster Shards (only for top 20% of users)",
      "Boost your chance of getting rewards",
    ],
  },
  startDate: new Date("2025-04-19T12:00:00Z"),
  endDate: new Date("2025-05-19T12:00:00Z"),
  availableOn: ["iOS", "Android", "Windows"],
});

const treeverseQuestsListConnect: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow on Immutable Play",
    caption: "Get exclusive content",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-wishlist-added",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-wishlist",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow @TheTreeverse on X",
    caption: "Don't miss a tweet",
    linkUrl: "https://x.com/TheTreeverse",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-twitter-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-twitter",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Treeverse Discord",
    caption: "Join our massively growing community",
    linkUrl: "https://discord.com/invite/endlessclouds",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-discord-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-discord",
  },
];

const treeverseQuestsListPlay: Quest[] = [
  {
    type: "custom",
    key: "in-game",
    icon: "PlayGame",
    label: "Complete Daily Quests",
    caption: "10 points per day, capped at 21 days",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<progressPoints> / 210 <icon>",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-daily-checkin-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-daily-checkin",
    maxCompletionCount: 21,
    endDate: new Date("2025-05-19T12:00:00Z"),
    ruleModal: treeverseMainQuestRuleDaily,
  },
  {
    type: "custom",
    key: "in-game",
    icon: "PlayGame",
    label: "Reach level 30",
    caption: "Level up your character to level 30",
    increase: 25,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-reach-level-30-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-reach-level-30",
    ruleModal: treeverseMainQuestRule1,
  },
  {
    type: "custom",
    key: "in-game",
    icon: "PlayGame",
    label: "Max out all Skilling Master to Level 60",
    caption: "Master different skills in the game",
    increase: 50,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-skilling-mastery-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-skilling-mastery",
    ruleModal: treeverseMainQuestRule2,
  },
];

const treeverseQuestsListCompete: Quest[] = [
  {
    type: "custom",
    key: "in-game",
    icon: "PlayGame",
    label: "Complete End Game Dungeon Runs",
    caption: "Complete End Game Dungeon Runs",
    increase: 0,
    badgeIcon: "ImxRewards",
    badgeTemplate: "",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-complete-end-game-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-complete-end-game",
    ruleModal: treeverseMainQuestRule3,
  },
  {
    type: "custom",
    key: "in-game",
    icon: "PlayGame",
    label: "Collect Gold",
    caption: "Collect Gold",
    increase: 0,
    badgeIcon: "ImxRewards",
    badgeTemplate: "",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-collected-gold-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-collected-gold",
    ruleModal: treeverseMainQuestRule4,
  },
  {
    type: "custom",
    key: "in-game",
    icon: "PlayGame",
    label: "Earn XP",
    caption: "Earn XP",
    increase: 0,
    badgeIcon: "ImxRewards",
    badgeTemplate: "",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-earned-xp-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-earned-xp",
    ruleModal: treeverseMainQuestRule5,
  },
  {
    type: "custom",
    key: "in-game",
    icon: "PlayGame",
    label: "Collect Monster Shards",
    caption: "Collect Monster Shards",
    increase: 0,
    badgeIcon: "ImxRewards",
    badgeTemplate: "",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-monster-shards-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-monster-shards",
    ruleModal: treeverseMainQuestRule6,
  },
];

const treeverseQuestsListOwn: Quest[] = [
  // {
  //   type: "custom",
  //   key: "ownership",
  //   icon: "Coins",
  //   label: "Own $IMX",
  //   caption: "1 point per $IMX, capped at 50 points.",
  //   increase: 50,
  //   badgeIcon: "ImxRewards",
  //   badgeTemplate: "+<progressPoints> / <increase> <icon>",
  //   eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-own-imx-event",
  //   ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-own-imx",
  //   assetHoldingType: "erc20",
  //   assetHoldingToken: {
  //     name: "IMX",
  //     image: "https://treeverse-assets.s3.amazonaws.com/imx-token.png",
  //     collectionAddress: "0xF57e7e7C23978C3cAEC3C3548E3D615c346e79fF",
  //     minimumBalance: 1,
  //     pointsMultiplier: 1,
  //     purchaseUrl: "https://www.immutable.com/token",
  //   },
  // },
  {
    type: "custom",
    key: "ownership",
    icon: "Coins",
    label: "Own $MON",
    caption: "1 point per $MON, capped at 50 points.",
    increase: 50,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<progressPoints> / <increase> <icon>",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-own-mon-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-own-mon",
    assetHoldingType: "erc20",
    assetHoldingToken: {
      name: "MON",
      image: "https://treeverse-assets.s3.amazonaws.com/mon-token.png",
      collectionAddress: "0x1e35eBa4a0709fF8B57A1a9260bCD48088FDA8d4",
      minimumBalance: 1,
      pointsMultiplier: 1,
      purchaseUrl: "https://www.treeverse.net/token",
    },
  },
  {
    type: "custom",
    key: "ownership",
    icon: "Coins",
    label: "Own Treeverse plot NFT",
    caption: "10 points per asset, capped at 70 points.",
    increase: 70,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<progressPoints> / <increase> <icon>",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-own-treeverse-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-own-treeverse",
    assetHoldingType: "erc721",
    assetHoldingToken: {
      name: "Treeverse Plot or Timeless",
      image: "https://treeverse-assets.s3.amazonaws.com/treeverse-plot.png",
      collectionAddress: "0x64931F06d3266049Bf0195346973762E6996D764",
      minimumBalance: 1,
      pointsMultiplier: 10,
      purchaseUrl: "https://tokentrove.com/collection/treeverse",
    },
  },
  {
    type: "custom",
    key: "ownership",
    icon: "Coins",
    label: "Own Timeless NFT",
    caption: "10 points per asset, capped at 70 points.",
    increase: 70,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<progressPoints> / <increase> <icon>",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-own-timeless-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-own-timeless",
    assetHoldingType: "erc721",
    assetHoldingToken: {
      name: "Treeverse Plot or Timeless",
      image: "https://treeverse-assets.s3.amazonaws.com/treeverse-plot.png",
      collectionAddress: "0x64931F06d3266049Bf0195346973762E6996D764",
      minimumBalance: 1,
      pointsMultiplier: 10,
      purchaseUrl: "https://tokentrove.com/collection/treeverse",
    },
  },
  {
    type: "custom",
    key: "ownership",
    icon: "Coins",
    label: "Own Niftrees NFT",
    caption: "25 points per asset, capped at 100 points.",
    increase: 100,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<progressPoints> / <increase> <icon>",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-own-niftrees-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-own-niftrees",
    assetHoldingType: "erc721",
    assetHoldingToken: {
      name: "Niftrees",
      image: "https://treeverse-assets.s3.amazonaws.com/niftrees.png",
      collectionAddress: "0xe8D09CDB7Af81DDa9be787CF26b3F5717eE8b1D2",
      minimumBalance: 1,
      pointsMultiplier: 25,
      purchaseUrl: "https://tokentrove.com/collection/niftrees",
    },
  },
];

export const treeverseQuestsPoints: QuestGroup[] = [
  {
    key: "connect",
    header: {
      image: "",
      description: "",
      title: "Connect",
    },
    totalGemsGranted: 0,
    quests: treeverseQuestsListConnect,
    questGroup: MAIN_QUESTS_GROUP,
  },
  {
    key: "play",
    header: {
      image: "",
      description: "",
      title: "Play",
    },
    totalGemsGranted: 0,
    quests: treeverseQuestsListPlay,
    questGroup: MAIN_QUESTS_GROUP,
  },
  {
    key: "compete",
    header: {
      image: "",
      description: "",
      title: "Compete",
    },
    totalGemsGranted: 0,
    quests: treeverseQuestsListCompete,
    questGroup: MAIN_QUESTS_GROUP,
  },
  // {
  //   key: "own",
  //   header: {
  //     image: "",
  //     description: "",
  //     title: "Own",
  //   },
  //   totalGemsGranted: 0,
  //   quests: treeverseQuestsListOwn,
  //   questGroup: MAIN_QUESTS_GROUP,
  // },
];
